import React from 'react';
import {reduxForm} from 'redux-form';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import {enumTypes, getEnumLabel} from '../../../../../utils/enumHelper';
import CheckMarkCell from '../../../../Common/CustomGridCells/CheckMarkCell/checkMarkCell';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import GridHelper from 'infrastructure/js/components/Grid/Utils/gridHelper';
import {EntityPropertyTypes} from '../../../../../enums/entityPropertyTypes';
import {FetchEntitiesFilters} from '../../../../../enums/fetchEntitiesFilters';
import PermissionManager from 'infrastructure/js/utils/permissionManager';

require('./qplsViewGrid.scss');

class QplsViewGrid extends React.PureComponent {

  filterConfig = [
    // {fieldName: 'name', filterName: 'name', getOptions: true},
    //Note: workaround - to make the sorting work. 'colId' for this column gets set to 'ag-Grid-AutoColumn' by ag-grid
    {fieldName: 'ag-Grid-AutoColumn', filterName: 'name', getOptions: true},
    {fieldName: 'createdByUser', filterName: 'createdByUser', getOptions: false },
    {fieldName: 'activatedByUser', filterName: 'activatedByUser', getOptions: false },
  ];

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.qpls.grid.');

    this.columnsConfig = this.createColumnsConfig();
    this.autoGroupColumnDef = {
      fieldName: 'name',
      title: this.labels.get('columns.qplName.title'),
      filterType: filterTypes.MULTI_SELECT_ASYNC,
      filterName: 'name',
      fetchConfig: {
        entityType: EntityPropertyTypes.QPL_NAME,
        filter: [FetchEntitiesFilters.DISTINCT_NAME],
        action: this.props.actions.fetchEntities
      },
      columnOptions:{
        valueGetter: ( params ) => {
          return params.data?.isParent ? params.data?.name : null;
        },
        cellRendererParams: {
          innerRenderer: LabelWithTooltipCell,
          suppressCount: true,
        },
      }
    }
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'version',
        title: this.labels.get('columns.qplVersion.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'isActive',
        title: this.labels.get('columns.active.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: CheckMarkCell,
        }
      },
      {
        fieldName: 'lastUpdated',
        title: this.labels.get('columns.lastUpdate.title'),
        filterType: filterTypes.NONE, //filterTypes.DATE_SELECT,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data ? DateTimeHelper.DateTimeFormat(params.data?.lastUpdated?.epochDateTime * 1000) : '';
          },
          headerComponentParams: GridHelper.getDateFormatHeaderIcon(),
        }
      },
      {
        fieldName: 'overallPassCriteria',
        title: this.labels.get('columns.overallQplValidation.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return getEnumLabel(enumTypes.OVERALL_PASS_CRITERIA)(params.data.overallPassCriteria);
          },
        }
      },
      ...( PermissionManager.isQplEnabled() ? [
        {
          fieldName: 'createdByUser',
          title: this.labels.get('columns.createdBy.title'),
          filterType: filterTypes.NONE,
          columnOptions: {
            cellComponent: LabelWithTooltipCell,
          },
        },
        {
          fieldName: 'activatedByUser',
          title: this.labels.get('columns.approvedBy.title'),
          filterType: filterTypes.NONE,
          columnOptions: {
            cellComponent: LabelWithTooltipCell,
          },
        },
      ] : []),
    ]
  };

  render() {
    return (
      <div className="administration-view-grid qpls-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS}
              columnsConfig={this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
              gridProps={{
                treeData: true,
                getDataPath: (data) => {
                  return data.hierarchy;
                },
                autoGroupColumnDef: this.autoGroupColumnDef,
                animateRows: true,
              }}
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'qplsViewGrid'
  }
)(QplsViewGrid);
